import angular from 'angular';
import ngResource from 'angular-resource';

function ModelFactory($route, $resource, $rootScope) {
  return class Model {
    constructor(data = {}) {

      this.data = data;
      this.api = {};
      this.promises = {};
      this.error = {};
      this.busy = false;
      this.setters = [];
    }
    registerErrorCleaner() {
      // $on returns an a function to deregister listener
      var deregisterListener = $rootScope.$on('$routeChangeStart', () => {
        delete this.error;
        deregisterListener();
      });
    }
    setData(data = this.data) {
      this.data = data;
      this.setters.forEach(setter => {
        setter(this.data)
      });
    }
    setProp(key, value) {
      if (!key) {
        return
      }
      this.data[key] = value;
      this.setData();
    }
    setMethod(name, method, defaultParams, conf) {
      this.api[name] = (params = {}, payload) => {

        // Block 'replay' requests for non-GET methods unless
        // cancellable requests are enabled
        if (this.busy && !method.cancellable && method.method !== 'GET') {
          return this.promises[name].$promise;
        }
        if ((method.cancellable || conf.cancellable) &&
          this.promises[name] &&
          this.promises[name].hasOwnProperty('$cancelRequest')) {
          this.promises[name].$cancelRequest();
        }
        this.busy = true;

        // set default params and payload
        if (/GET|PUT|POST|DELETE/.test(method.method) && !payload) {
          payload = this.data;
        }
        if (defaultParams && defaultParams.caseId && !params.caseId) {
          params.caseId = $route.current.params.caseId;
        }

        this.promises[name] = this.resource[name](params, payload, (data) => {

          if (typeof method.success === 'undefined') {
            this.success(data);
          } else {
            method.success.forEach((cb) => {
              cb(data);
            });
          }

          this.busy = false;

          delete this.error;

        }, (response) => {

          if (typeof method.fail === 'undefined') {
            this.fail(response);
          } else {
            method.fail.forEach(cb => {
              cb(response);
            });
          }

          this.busy = false;

        });
        return this.promises[name].$promise;
      };
    }
    setApi(enpoint, defaultParams, methods, conf = {}) {
      this.resource = $resource(enpoint, defaultParams, methods, conf);

      // wrap resource in promise, set busy, run success / fail callbacks
      // declared in model methods
      Object.keys(methods)
        .forEach(method => this.setMethod(method, methods[method],
          defaultParams, conf));
    }

    getData() {
      return this.data;
    }
    subscribe(setter) {
      this.setters.push(setter);
      setter(this.data);
    }

    success(data) {
      this.setData(data);
    }
    fail(response) {
      this.registerErrorCleaner();
      this.error = response.data;
    }

  };
}
ModelFactory.$inject = ['$route', '$resource', '$rootScope'];

export default angular.module('models.model', [ngResource])
  .factory('Model', ModelFactory)
  .name;



// WEBPACK FOOTER //
// ./project/models/model.js